import axios from './api'

export const getHome = () => {
  return axios.get(`/site/content/home?v=${Math.random()}`)
    .then(res => res.data.data.home)
}